import { ChangeEvent, FormEvent, useState } from 'react';

type Input = HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement;

export const useFormData = <TData>(initailState: TData) => {
  const [data, setData] = useState(initailState);

  const handleChange = (e: ChangeEvent<Input>) => {
    setData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };
  const handleChanged = (e: ChangeEvent<Input>) => {
    debugger;
    setData((prev) => ({
      ...prev,
      [e.target.name]: true,
    }));
  };
 
  const handleChangeNumber = (e: ChangeEvent<Input>) => {
    setData((prev) => ({
      ...prev,
      [e.target.name]: +e.target.value,
    }));
  };

  const reset = () => setData(initailState);

  const register = (
    name: keyof TData,
    type: 'string' | 'number' = 'string'
  ): {
    name: keyof TData;
    value: any;
    onChange: (e: ChangeEvent<Input>) => void;
  } => {
    return {
      name,
      value: data[name],
      onChange: type === 'string' ? handleChange : handleChangeNumber,
    };
  };

  const handleSubmit = (callback: (data: TData) => void) => (e: FormEvent) => {
    e.preventDefault();
    callback(data);
  };

  return {
    data,
    setData,
    handleChange,
    handleChangeNumber,
    reset,
    register,
    handleSubmit,
    handleChanged
    
  };
};
